export const translations = {
  en: {
    nav: {
      about: "About",
      services: "Services",
      capabilities: "Capabilities",
      projects: "Projects",
      presence: "Global Presence",
      portfolio: "Portfolio",
      careers: "Careers",
      contact: "Private Advisory",
      privacy: "Privacy",
      language: "ES",
      cta: "Request Consultation",
    },
    hero: {
      eyebrow: "Oil & Gas · Engineering · Private Advisory",
      title_1: "Strategic Intelligence",
      title_2: "& Engineering",
      title_3: "for the Energy Sector",
      subtitle:
        "Precision, safety and operational excellence across drilling, pipelines, offshore platforms, inspection and industrial infrastructure — for the world's most demanding energy operators.",
      primary: "Request Private Consultation",
      secondary: "Explore Capabilities",
      scroll: "Scroll to discover",
      marquee: "Engineering · Inspection · Procurement · Construction · HSE · Integrity",
    },
    about: {
      eyebrow: "About DEPP C&M",
      title: "Engineered for scale. Delivered with precision.",
      p1:
        "DEPP C&M, S.A. DE C.V. is a private advisory and engineering firm serving operators across the upstream, midstream and downstream oil & gas value chain.",
      p2:
        "We combine multi-disciplinary engineering teams, high-capacity field operations and a disciplined inspection culture to deliver projects that meet international standards — from Mexican basins to the Gulf of Mexico and beyond.",
      pillars: [
        { k: "High-capacity operations", v: "Crews, rigging & fabrication workshops ready to mobilize 24/7." },
        { k: "Multi-disciplinary engineering", v: "Conceptual to detail engineering under a single integrated team." },
        { k: "International presence", v: "Active operations in Mexico and strategic hubs in the United States." },
        { k: "Safety & profitability", v: "HSE-first culture aligned with OSHA, API and ISO frameworks." },
      ],
    },
    services: {
      eyebrow: "Capabilities",
      title: "Integrated practices. One accountable partner.",
      subtitle:
        "From first-principle engineering to heavy-equipment fabrication, offshore operations, crane & rigging logistics and regulatory compliance — we operate where precision is non-negotiable.",
      items: [
        {
          tag: "A",
          name: "Engineering & Infrastructure",
          desc: "Conceptual, basic and detailed engineering. Pipeline systems for gas, oil and condensate. Process design, P&IDs and flow diagrams.",
          bullets: [
            "Conceptual / Basic / Detail engineering",
            "Pipeline systems — gas, oil, condensate",
            "Process design · P&ID · Flow diagrams",
            "Civil works, buildings & urbanization",
          ],
        },
        {
          tag: "B",
          name: "Field Operations & Drilling",
          desc: "Wellhead installation and maintenance, pressure-control equipment, swabbing and artificial-lift systems.",
          bullets: [
            "Wellhead install & maintenance",
            "Valves & pressure-control equipment",
            "Swabbing · Artificial-lift systems",
            "Well commissioning & workover support",
          ],
        },
        {
          tag: "C",
          name: "Offshore Platforms & Vessels",
          desc: "Integral rental, operation and maintenance of offshore platforms — jack-up, semi-submersible, drilling ships, fixed and modular units.",
          bullets: [
            "Jack-up · Semi-submersible · Drillships",
            "Fixed & modular platform maintenance",
            "Offshore commissioning & start-up",
            "Marine logistics & victualling",
          ],
        },
        {
          tag: "D",
          name: "Industrial Maintenance & Inspection",
          desc: "Preventive and corrective maintenance, non-destructive testing (NDT), mechanical integrity and risk-based analysis.",
          bullets: [
            "Preventive & corrective maintenance",
            "Non-destructive testing (NDT)",
            "Mechanical integrity · Risk-based inspection",
            "Plant & equipment turnaround",
          ],
        },
        {
          tag: "E",
          name: "Cranes, Rigging & Heavy Lift",
          desc: "Industrial crane rental and heavy-lift maneuvers for upstream, midstream and offshore projects — compliant with national and international safety standards.",
          bullets: [
            "Land cranes · HIABs · Forklifts",
            "Heavy-lift maneuvers & rigging",
            "Certified operators & riggers",
            "Nationwide mobilization",
          ],
        },
        {
          tag: "F",
          name: "Fabrication & Heavy Equipment",
          desc: "Pressure vessels, tanks and heat exchangers. Cryogenic and fuel-transport systems.",
          bullets: [
            "Pressure vessels · Tanks · Exchangers",
            "Cryogenic systems",
            "Fuel-transport systems",
            "Skid-mounted packages",
          ],
        },
        {
          tag: "G",
          name: "Fire Protection & Industrial Safety",
          desc: "NFPA- and FM Global-aligned fire protection: engineering, supply, installation and maintenance of water-based, clean-agent and specialty suppression systems.",
          bullets: [
            "Sprinklers · Pre-action · Deluge · Dry/Wet",
            "Clean agents — FM-200 · Novec 1230 · CO₂ · Argonite",
            "Detection, alarms & hydraulic pump rooms",
            "Underground piping & HDPE thermofusion",
          ],
        },
      ],
      extras_eyebrow: "Complementary services",
      extras_title: "A complete operating footprint.",
      extras: [
        {
          name: "HSE & Regulatory Compliance",
          desc: "Health, Safety & Environment programs aligned with OSHA, API, ISO and Mexican NOMs.",
        },
        {
          name: "Oily-Water Treatment",
          desc: "Collection and treatment of oily water from sumps, settling pits and process drains.",
        },
        {
          name: "Hydrocarbon Recovery",
          desc: "Specialized pumping and separation equipment for settling ponds and industrial sumps.",
        },
        {
          name: "Specialized Personnel Supply",
          desc: "Certified engineering, operations, QA/QC and field personnel on long-term assignments.",
        },
        {
          name: "Logistics & Victualling",
          desc: "Administration, logistics and victualling support for offshore and remote operations.",
        },
        {
          name: "Civil Works & Buildings",
          desc: "Industrial civil works, edifications and urbanization for oil & gas and power projects.",
        },
      ],
    },
    metrics: {
      eyebrow: "Operational footprint",
      title: "Numbers that define the practice.",
      items: [
        { value: 420, suffix: "+", label: "Projects delivered", sub: "upstream · midstream · downstream" },
        { value: 180, suffix: "+", label: "Certified personnel", sub: "engineering · field · QA/QC" },
        { value: 18, suffix: "", label: "Years of practice", sub: "serving national & international operators" },
        { value: 24, suffix: "/7", label: "Operational readiness", sub: "mobilization & emergency response" },
      ],
    },
    certs: {
      eyebrow: "Certifications & Standards",
      title: "Compliant with the frameworks the industry trusts.",
    },
    projects: {
      eyebrow: "Selected experience",
      title: "Projects built to withstand scrutiny.",
      subtitle: "A representative cross-section of recent assignments in gas processing, pressure-vessel fabrication and mechanical integrity.",
      items: [
        {
          name: "Gas Regeneration Tower",
          meta: "Midstream · Processing · Commissioning",
          desc: "Engineering, procurement supervision and commissioning support for a regeneration column within a gas treatment skid — insulation, tie-ins and pressure-containing equipment integrity.",
        },
        {
          name: "Amine Treatment Column",
          meta: "Upstream · Gas Sweetening · Integrity",
          desc: "Mechanical integrity review, NDT inspection and corrective maintenance plan for a stripping column and its associated piping network in an H₂S-removal service.",
        },
        {
          name: "Horizontal Separator — Pressure Vessel",
          meta: "Fabrication · ASME U-stamp · Inspection",
          desc: "Procurement, fabrication inspection and QA/QC sign-off of a horizontal three-phase separator and associated pressure-control skid for field deployment.",
        },
      ],
      tag: "View case brief",
      gallery_eyebrow: "Project photography",
      gallery_title: "From the field.",
      gallery_subtitle: "Real equipment and assignments in which DEPP C&M has participated.",
    },
    presence: {
      eyebrow: "Global Presence",
      title: "Strategic hubs. Global reach.",
      subtitle: "Active operations and advisory desks positioned to serve operators across the Americas, the Middle East and Europe.",
      hubs: [
        { city: "Villahermosa", country: "Mexico", role: "HQ · Engineering & Operations" },
        { city: "Ciudad del Carmen", country: "Mexico", role: "Offshore Field Base" },
        { city: "Houston, TX", country: "USA", role: "Advisory & Procurement Desk" },
        { city: "Monterrey", country: "Mexico", role: "Fabrication & Heavy Equipment" },
      ],
    },
    careers: {
      eyebrow: "Careers · Join the team",
      title: "Build the energy projects the world counts on.",
      subtitle:
        "We hire engineers, inspectors, field supervisors, riggers, welders and HSE specialists for projects across Mexico and the Gulf of Mexico. Submit your profile — our talent desk reviews applications weekly.",
      perks: [
        { k: "International projects", v: "Exposure to operators across Mexico, USA and the Middle East." },
        { k: "Certified training", v: "Continuous OSHA, API, ASNT and HSE training programs." },
        { k: "Life insurance & benefits", v: "Competitive compensation and full benefits package." },
        { k: "Career mobility", v: "Clear progression between engineering, operations and advisory." },
      ],
      openings_title: "Current profiles in demand",
      openings: [
        { role: "NDT Inspector (Levels II / III)", area: "Inspection · QA/QC", loc: "Villahermosa / Cd. del Carmen" },
        { role: "Process / Pipeline Engineer", area: "Engineering", loc: "Villahermosa · Houston" },
        { role: "Offshore Rigger / Crane Operator", area: "Field Operations", loc: "Offshore · Gulf of Mexico" },
        { role: "HSE Supervisor", area: "Safety & Compliance", loc: "Nationwide · Mexico" },
        { role: "Mechanical Maintenance Technician", area: "Maintenance", loc: "Monterrey · Field" },
        { role: "Welder (SMAW / GTAW, coded)", area: "Fabrication", loc: "Monterrey · Field" },
      ],
      fields: {
        name: "Full name",
        email: "Email",
        phone: "Phone",
        position: "Position of interest",
        position_ph: "Select a role",
        experience: "Years of experience",
        location: "Preferred location",
        message: "Cover note / highlights",
        message_ph: "Briefly describe your experience, certifications and availability...",
        cv_note: "You will be asked for your CV after your profile is pre-qualified.",
        consent: "I accept the Privacy Notice and authorize the processing of my personal data for recruitment purposes.",
      },
      submit: "Submit Application",
      submitting: "Submitting...",
      success: "Application received. Our talent desk will review your profile.",
      error: "Submission failed. Please try again.",
    },
    contact: {
      eyebrow: "Private Advisory",
      title: "Request a confidential consultation.",
      subtitle: "Our advisory desk responds to qualified inquiries within one business day. All submissions are treated as confidential.",
      fields: {
        name: "Full name",
        company: "Company",
        email: "Corporate email",
        phone: "Phone (optional)",
        country: "Country",
        project_type: "Project type",
        message: "Briefing",
        message_ph: "Describe the scope, timeframe and any confidentiality considerations...",
        confidential: "Treat this inquiry as confidential",
        consent: "I accept the Privacy Notice and authorize the processing of my personal data.",
      },
      types: [
        "Engineering & Infrastructure",
        "Drilling & Field Operations",
        "Offshore Platforms & Vessels",
        "Maintenance & Inspection",
        "Cranes, Rigging & Heavy Lift",
        "Fabrication & Heavy Equipment",
        "HSE & Compliance",
        "Specialized Services",
        "Other",
      ],
      submit: "Submit Inquiry",
      submitting: "Transmitting...",
      success: "Inquiry received. Our advisory desk will be in touch.",
      error: "Transmission failed. Please try again or email us directly.",
      consent_required: "Please accept the Privacy Notice to continue.",
    },
    footer: {
      tagline: "Strategic intelligence & engineering for the energy sector.",
      rights: "All rights reserved.",
      nav: "Navigate",
      contact: "Contact",
      legal: "Legal",
      privacy: "Privacy Notice",
      terms: "Terms of Use",
      careers: "Careers",
    },
    presentation: {
      cta: "Download Capability Statement",
      cta_short: "Download Deck",
      modal_eyebrow: "Capability Statement · Download",
      modal_title: "Receive a premium, personalized capability deck.",
      modal_subtitle:
        "Share a few details and we will generate a PDF deck tailored to your company and sector. The document is strictly confidential.",
      fields: {
        name: "Full name",
        company: "Company",
        email: "Corporate email",
        phone: "Phone (optional)",
        country: "Country",
        role: "Your role (optional)",
        template: "Presentation focus",
        sector_focus: "Sector / Area of interest (optional)",
        consent: "I accept the Privacy Notice and authorize the processing of my personal data.",
      },
      templates: {
        oil_gas: "Oil & Gas / Industrial",
        corporate: "General Corporate",
      },
      submit: "Generate & Download",
      generating: "Generating PDF...",
      success: "Your deck is ready — the download has started.",
      success_retry: "Download again",
      error: "Generation failed. Please try again.",
      close: "Close",
    },
    privacy: {
      eyebrow: "Legal · Privacy",
      title: "Privacy Notice",
      updated: "Last updated",
      intro_title: "Integral Privacy Notice",
      back: "Back to site",
      toc: "On this page",
      sections: [
        {
          id: "controller",
          heading: "1. Data Controller",
          body:
            "DEPP C&M, S.A. DE C.V. (\"DEPP C&M\", \"we\", \"us\" or \"the Company\"), with registered offices in Villahermosa, Tabasco, Mexico, and operational desks in Houston, TX (USA), is the party responsible for the processing, use and protection of your personal data, in accordance with Mexico's Federal Law on the Protection of Personal Data Held by Private Parties (\"LFPDPPP\"), its Regulations, and applicable privacy laws of the United States (including, where applicable, the California Consumer Privacy Act, \"CCPA\"/\"CPRA\").",
        },
        {
          id: "data",
          heading: "2. Personal data we collect",
          body:
            "Depending on the channel you use to interact with us, DEPP C&M may collect the following categories of personal data:",
          list: [
            "Identification data: full name, nationality, signature, photograph.",
            "Contact data: corporate email, phone number, country of residence, company, job title.",
            "Commercial and professional data: company size, role, project type, technical briefing, scope, timeframe.",
            "Employment-related data (for applicants): resume/CV, education, certifications (OSHA, API, ASNT, ISO), years of experience, expected role, compensation expectations, references.",
            "Browsing data: IP address, device type, browser, approximate location, pages visited, timestamps (via cookies and analytics).",
          ],
          body2:
            "We do not knowingly collect sensitive personal data. We do not collect personal data from minors.",
        },
        {
          id: "purposes",
          heading: "3. Purposes of processing",
          body: "Primary purposes (necessary to maintain the relationship):",
          list: [
            "Attend to inquiries submitted through the Private Advisory form.",
            "Evaluate commercial and technical feasibility of a potential engagement.",
            "Issue proposals, contracts, invoicing and provide contracted services.",
            "Manage applications to our talent pool and recruitment processes.",
            "Comply with legal, tax, regulatory and contractual obligations.",
            "Ensure information security and integrity of our systems.",
          ],
          body2: "Secondary purposes (you may opt out at any time):",
          list2: [
            "Send commercial communications, newsletters and industry insights.",
            "Invite you to events, webinars and publications.",
            "Market research and service-quality surveys.",
          ],
          body3:
            "If you do not wish your personal data to be used for secondary purposes, please indicate so by emailing privacy@deppcm.com. Refusal will not condition the provision of the primary service.",
        },
        {
          id: "transfers",
          heading: "4. Data transfers",
          body:
            "DEPP C&M may transfer your personal data, without requiring your consent under articles 37 of the LFPDPPP and applicable U.S. exceptions, in the following cases:",
          list: [
            "To affiliates, subsidiaries or group companies of DEPP C&M for the same purposes stated herein.",
            "To authorities, regulators or courts when required by law.",
            "To auditors, legal advisors, tax advisors and insurers bound by confidentiality.",
            "To subcontractors and service providers strictly necessary for the execution of a contracted project, bound by confidentiality and equivalent data protection obligations.",
          ],
          body2:
            "Any transfer outside these scenarios will require your prior consent. We do not sell your personal data.",
        },
        {
          id: "arco",
          heading: "5. ARCO rights and CCPA consumer rights",
          body:
            "You have the right to Access, Rectify, Cancel, or Oppose (ARCO) the processing of your personal data, as well as to limit their use or disclosure and to revoke the consent granted. If you are a California resident, you also have the right to know, delete, correct, opt out of sale/sharing, and non-discrimination under CCPA/CPRA.",
          body2:
            "To exercise these rights, please send a written request to privacy@deppcm.com, including: (i) your full name and means of contact; (ii) documents proving your identity or legal representation; (iii) a clear description of the personal data and the right you wish to exercise; and (iv) any additional element that facilitates locating your data. We will respond within the terms established by applicable law (20 business days under LFPDPPP; 45 days under CCPA).",
        },
        {
          id: "revoke",
          heading: "6. Revocation of consent",
          body:
            "At any time you may revoke the consent you have granted for the processing of your personal data. However, your request may not be immediately effective where a legal obligation requires us to continue processing your data, or where termination of processing would affect an existing legal relationship.",
        },
        {
          id: "cookies",
          heading: "7. Cookies and tracking technologies",
          body:
            "Our website may use cookies, web beacons and similar technologies to: (i) ensure basic operation of the site; (ii) remember language preferences; (iii) measure audience and usage patterns (analytics). You may disable these technologies through your browser settings, which may limit certain functionalities.",
        },
        {
          id: "security",
          heading: "8. Security measures",
          body:
            "DEPP C&M has implemented administrative, technical and physical security measures reasonably aligned with ISO/IEC 27001 principles and ISMS good practices, to protect your personal data against damage, loss, alteration, destruction, or unauthorized use, access or processing.",
        },
        {
          id: "retention",
          heading: "9. Retention",
          body:
            "Personal data will be retained only for the period necessary to fulfill the purposes described, plus the statutory retention periods required by Mexican and U.S. law (including tax and labor regulations). Afterwards, they will be deleted or anonymized.",
        },
        {
          id: "changes",
          heading: "10. Changes to this notice",
          body:
            "This Privacy Notice may be updated to reflect legal, operational or technological changes. Any modification will be published on this page with an updated version date. Continued use of our services after publication of the changes implies your acceptance.",
        },
        {
          id: "contact",
          heading: "11. Contact — Data Protection Officer",
          body:
            "For any question related to the processing of your personal data, or to exercise your ARCO or CCPA rights, please contact: DEPP C&M — Data Protection Officer · privacy@deppcm.com · Villahermosa, Tabasco, Mexico.",
        },
      ],
      accept: "I understand",
    },
  },
  es: {
    nav: {
      about: "Nosotros",
      services: "Servicios",
      capabilities: "Capacidades",
      projects: "Proyectos",
      presence: "Presencia Global",
      portfolio: "Portafolio",
      careers: "Bolsa de Trabajo",
      contact: "Asesoría Privada",
      privacy: "Privacidad",
      language: "EN",
      cta: "Solicitar Consulta",
    },
    hero: {
      eyebrow: "Petróleo y Gas · Ingeniería · Asesoría Privada",
      title_1: "Inteligencia Estratégica",
      title_2: "e Ingeniería",
      title_3: "para el Sector Energético",
      subtitle:
        "Precisión, seguridad y excelencia operativa en perforación, ductos, plataformas offshore, inspección e infraestructura industrial — para los operadores energéticos más exigentes del mundo.",
      primary: "Solicitar Consulta Privada",
      secondary: "Explorar Capacidades",
      scroll: "Desliza para descubrir",
      marquee: "Ingeniería · Inspección · Procura · Construcción · HSE · Integridad",
    },
    about: {
      eyebrow: "Acerca de DEPP C&M",
      title: "Diseñado a escala. Entregado con precisión.",
      p1:
        "DEPP C&M, S.A. DE C.V. es una firma privada de asesoría e ingeniería que atiende a operadores en toda la cadena de valor del petróleo y gas: upstream, midstream y downstream.",
      p2:
        "Combinamos equipos multidisciplinarios de ingeniería, operaciones de campo de alta capacidad y una cultura disciplinada de inspección para entregar proyectos que cumplen estándares internacionales — desde cuencas mexicanas hasta el Golfo de México y más allá.",
      pillars: [
        { k: "Operaciones de alta capacidad", v: "Cuadrillas, equipos de izaje y talleres listos para movilizarse 24/7." },
        { k: "Ingeniería multidisciplinaria", v: "Ingeniería conceptual a detalle bajo un mismo equipo integrado." },
        { k: "Presencia internacional", v: "Operaciones activas en México y hubs estratégicos en Estados Unidos." },
        { k: "Seguridad y rentabilidad", v: "Cultura HSE-first alineada con OSHA, API e ISO." },
      ],
    },
    services: {
      eyebrow: "Capacidades",
      title: "Prácticas integradas. Un solo socio responsable.",
      subtitle:
        "De la ingeniería de primeros principios a la fabricación de equipo pesado, operaciones offshore, logística de grúas e izaje y cumplimiento regulatorio — operamos donde la precisión no es negociable.",
      items: [
        {
          tag: "A",
          name: "Ingeniería e Infraestructura",
          desc: "Ingeniería conceptual, básica y de detalle. Sistemas de ductos para gas, crudo y condensados. Diseño de procesos, P&IDs y diagramas de flujo.",
          bullets: [
            "Ingeniería conceptual / básica / detalle",
            "Ductos — gas, crudo, condensado",
            "Diseño de procesos · P&ID · Flujos",
            "Obra civil, edificaciones y urbanización",
          ],
        },
        {
          tag: "B",
          name: "Operaciones de Campo y Perforación",
          desc: "Instalación y mantenimiento de cabezales de pozo, equipos de control de presión, swabbing y sistemas de levantamiento artificial.",
          bullets: [
            "Instalación y mantenimiento de cabezales",
            "Válvulas y control de presión",
            "Swabbing · Levantamiento artificial",
            "Comisionamiento y workover",
          ],
        },
        {
          tag: "C",
          name: "Plataformas Offshore y Embarcaciones",
          desc: "Renta, operación y mantenimiento integral de plataformas costa afuera — jack-up, semisumergibles, barcos perforadores, fijas y modulares.",
          bullets: [
            "Jack-up · Semisumergibles · Drillships",
            "Plataformas fijas y modulares",
            "Comisionamiento y arranque offshore",
            "Logística marítima y avituallamiento",
          ],
        },
        {
          tag: "D",
          name: "Mantenimiento Industrial e Inspección",
          desc: "Mantenimiento preventivo y correctivo, pruebas no destructivas (NDT), integridad mecánica y análisis basado en riesgo.",
          bullets: [
            "Mantenimiento preventivo y correctivo",
            "Pruebas no destructivas (NDT)",
            "Integridad mecánica · RBI",
            "Paros de planta y turnaround",
          ],
        },
        {
          tag: "E",
          name: "Grúas, Izaje y Maniobras",
          desc: "Renta de grúas industriales y maniobras de izaje pesado para proyectos upstream, midstream y offshore — cumpliendo normas nacionales e internacionales de seguridad.",
          bullets: [
            "Grúas terrestres · HIABs · Montacargas",
            "Maniobras de izaje pesado y rigging",
            "Operadores y rigger certificados",
            "Movilización a nivel nacional",
          ],
        },
        {
          tag: "F",
          name: "Fabricación y Equipo Pesado",
          desc: "Recipientes a presión, tanques e intercambiadores de calor. Sistemas criogénicos y de transporte de combustibles.",
          bullets: [
            "Recipientes · Tanques · Intercambiadores",
            "Sistemas criogénicos",
            "Transporte de combustibles",
            "Paquetes skid-mounted",
          ],
        },
        {
          tag: "G",
          name: "Protección Contra Incendio y Seguridad Industrial",
          desc: "Protección contra incendio bajo NFPA y FM Global: ingeniería, suministro, instalación y mantenimiento de sistemas a base de agua, agentes limpios y supresión especializada.",
          bullets: [
            "Rociadores · Pre-acción · Diluvio · Secos/Húmedos",
            "Agentes limpios — FM-200 · Novec 1230 · CO₂ · Argonite",
            "Detección, alarmas y cuartos de bombas",
            "Tubería subterránea y termofusión HDPE",
          ],
        },
      ],
      extras_eyebrow: "Servicios complementarios",
      extras_title: "Una huella operativa completa.",
      extras: [
        {
          name: "HSE y Cumplimiento Regulatorio",
          desc: "Programas de Salud, Seguridad y Ambiente alineados con OSHA, API, ISO y NOMs mexicanas.",
        },
        {
          name: "Tratamiento de Aguas Oleosas",
          desc: "Recolección y tratamiento de aguas aceitosas de cárcamos, presas de asentamiento y drenajes de proceso.",
        },
        {
          name: "Recuperación de Hidrocarburos",
          desc: "Equipo especializado de bombeo y separación para presas de asentamiento y cárcamos industriales.",
        },
        {
          name: "Suministro de Personal Especializado",
          desc: "Personal certificado de ingeniería, operaciones, QA/QC y campo para asignaciones de largo plazo.",
        },
        {
          name: "Logística y Avituallamiento",
          desc: "Soporte de administración, logística y avituallamiento para operaciones offshore y remotas.",
        },
        {
          name: "Obra Civil y Edificaciones",
          desc: "Obra civil industrial, edificaciones y urbanización para proyectos de petróleo, gas y energía.",
        },
      ],
    },
    metrics: {
      eyebrow: "Huella operativa",
      title: "Cifras que definen la práctica.",
      items: [
        { value: 420, suffix: "+", label: "Proyectos entregados", sub: "upstream · midstream · downstream" },
        { value: 180, suffix: "+", label: "Personal certificado", sub: "ingeniería · campo · QA/QC" },
        { value: 18, suffix: "", label: "Años de práctica", sub: "operadores nacionales e internacionales" },
        { value: 24, suffix: "/7", label: "Disponibilidad operativa", sub: "movilización y respuesta" },
      ],
    },
    certs: {
      eyebrow: "Certificaciones y Estándares",
      title: "Cumplimos con los marcos que la industria exige.",
    },
    projects: {
      eyebrow: "Experiencia seleccionada",
      title: "Proyectos construidos para resistir cualquier auditoría.",
      subtitle: "Una muestra representativa de asignaciones recientes en procesamiento de gas, fabricación de recipientes a presión e integridad mecánica.",
      items: [
        {
          name: "Torre de Regeneración de Gas",
          meta: "Midstream · Procesamiento · Comisionamiento",
          desc: "Ingeniería, supervisión de procura y soporte de comisionamiento para una columna de regeneración en un paquete de tratamiento de gas — aislamiento, tie-ins e integridad de equipos a presión.",
        },
        {
          name: "Columna de Tratamiento con Amina",
          meta: "Upstream · Endulzamiento · Integridad",
          desc: "Revisión de integridad mecánica, inspección NDT y plan de mantenimiento correctivo para una columna de despojamiento y su red de tubería asociada en servicio de remoción de H₂S.",
        },
        {
          name: "Separador Horizontal — Recipiente a Presión",
          meta: "Fabricación · ASME U-stamp · Inspección",
          desc: "Procura, inspección de fabricación y liberación QA/QC de un separador trifásico horizontal y su paquete de control de presión asociado para despliegue en campo.",
        },
      ],
      tag: "Ver resumen",
      gallery_eyebrow: "Fotografía de campo",
      gallery_title: "Desde el campo.",
      gallery_subtitle: "Equipos y asignaciones reales en las que ha participado DEPP C&M.",
    },
    presence: {
      eyebrow: "Presencia Global",
      title: "Hubs estratégicos. Alcance global.",
      subtitle: "Operaciones activas y mesas de asesoría posicionadas para servir a operadores en las Américas, Medio Oriente y Europa.",
      hubs: [
        { city: "Villahermosa", country: "México", role: "Matriz · Ingeniería y Operaciones" },
        { city: "Ciudad del Carmen", country: "México", role: "Base Offshore" },
        { city: "Houston, TX", country: "EE.UU.", role: "Mesa de Asesoría y Procura" },
        { city: "Monterrey", country: "México", role: "Fabricación y Equipo Pesado" },
      ],
    },
    careers: {
      eyebrow: "Bolsa de Trabajo · Únete al equipo",
      title: "Construye los proyectos energéticos en los que el mundo confía.",
      subtitle:
        "Reclutamos ingenieros, inspectores, supervisores de campo, riggers, soldadores y especialistas HSE para proyectos en México y el Golfo de México. Envía tu perfil — nuestra mesa de talento revisa aplicaciones semanalmente.",
      perks: [
        { k: "Proyectos internacionales", v: "Exposición a operadores de México, EE.UU. y Medio Oriente." },
        { k: "Capacitación certificada", v: "Programas continuos OSHA, API, ASNT y HSE." },
        { k: "Seguro de vida y prestaciones", v: "Compensación competitiva y paquete completo de prestaciones." },
        { k: "Movilidad de carrera", v: "Progresión clara entre ingeniería, operaciones y asesoría." },
      ],
      openings_title: "Perfiles en demanda actual",
      openings: [
        { role: "Inspector NDT (Nivel II / III)", area: "Inspección · QA/QC", loc: "Villahermosa / Cd. del Carmen" },
        { role: "Ingeniero de Procesos / Ductos", area: "Ingeniería", loc: "Villahermosa · Houston" },
        { role: "Rigger / Operador de Grúa Offshore", area: "Operaciones de Campo", loc: "Offshore · Golfo de México" },
        { role: "Supervisor HSE", area: "Seguridad y Cumplimiento", loc: "Nacional · México" },
        { role: "Técnico Mecánico de Mantenimiento", area: "Mantenimiento", loc: "Monterrey · Campo" },
        { role: "Soldador (SMAW / GTAW, codificado)", area: "Fabricación", loc: "Monterrey · Campo" },
      ],
      fields: {
        name: "Nombre completo",
        email: "Correo",
        phone: "Teléfono",
        position: "Puesto de interés",
        position_ph: "Selecciona un perfil",
        experience: "Años de experiencia",
        location: "Ubicación preferida",
        message: "Carta de presentación / resumen",
        message_ph: "Describe brevemente tu experiencia, certificaciones y disponibilidad...",
        cv_note: "Te solicitaremos tu CV una vez precalificado el perfil.",
        consent: "Acepto el Aviso de Privacidad y autorizo el tratamiento de mis datos personales para fines de reclutamiento.",
      },
      submit: "Enviar Aplicación",
      submitting: "Enviando...",
      success: "Aplicación recibida. Nuestra mesa de talento revisará tu perfil.",
      error: "Envío fallido. Intenta de nuevo.",
    },
    contact: {
      eyebrow: "Asesoría Privada",
      title: "Solicita una consulta confidencial.",
      subtitle: "Nuestra mesa de asesoría responde consultas calificadas en menos de un día hábil. Todas las solicitudes se tratan como confidenciales.",
      fields: {
        name: "Nombre completo",
        company: "Empresa",
        email: "Correo corporativo",
        phone: "Teléfono (opcional)",
        country: "País",
        project_type: "Tipo de proyecto",
        message: "Briefing",
        message_ph: "Describe el alcance, plazos y consideraciones de confidencialidad...",
        confidential: "Tratar esta consulta como confidencial",
        consent: "Acepto el Aviso de Privacidad y autorizo el tratamiento de mis datos personales.",
      },
      types: [
        "Ingeniería e Infraestructura",
        "Perforación y Operaciones de Campo",
        "Plataformas Offshore y Embarcaciones",
        "Mantenimiento e Inspección",
        "Grúas, Izaje y Maniobras",
        "Fabricación y Equipo Pesado",
        "HSE y Cumplimiento",
        "Servicios Especializados",
        "Otro",
      ],
      submit: "Enviar Consulta",
      submitting: "Transmitiendo...",
      success: "Consulta recibida. Nuestra mesa de asesoría se pondrá en contacto.",
      error: "Transmisión fallida. Intenta nuevamente o escríbenos directamente.",
      consent_required: "Debes aceptar el Aviso de Privacidad para continuar.",
    },
    footer: {
      tagline: "Inteligencia estratégica e ingeniería para el sector energético.",
      rights: "Todos los derechos reservados.",
      nav: "Navegar",
      contact: "Contacto",
      legal: "Legal",
      privacy: "Aviso de Privacidad",
      terms: "Términos de Uso",
      careers: "Bolsa de Trabajo",
    },
    presentation: {
      cta: "Descargar Capability Statement",
      cta_short: "Descargar Deck",
      modal_eyebrow: "Capability Statement · Descarga",
      modal_title: "Recibe un deck de capacidades personalizado y premium.",
      modal_subtitle:
        "Comparte algunos datos y generaremos un PDF adaptado a tu empresa y sector. El documento es estrictamente confidencial.",
      fields: {
        name: "Nombre completo",
        company: "Empresa",
        email: "Correo corporativo",
        phone: "Teléfono (opcional)",
        country: "País",
        role: "Tu puesto (opcional)",
        template: "Enfoque del deck",
        sector_focus: "Sector / Área de interés (opcional)",
        consent: "Acepto el Aviso de Privacidad y autorizo el tratamiento de mis datos personales.",
      },
      templates: {
        oil_gas: "Petróleo y Gas / Industrial",
        corporate: "Corporativo General",
      },
      submit: "Generar y Descargar",
      generating: "Generando PDF...",
      success: "Tu deck está listo — la descarga ha iniciado.",
      success_retry: "Descargar de nuevo",
      error: "Falló la generación. Intenta de nuevo.",
      close: "Cerrar",
    },
    privacy: {
      eyebrow: "Legal · Privacidad",
      title: "Aviso de Privacidad",
      updated: "Última actualización",
      intro_title: "Aviso de Privacidad Integral",
      back: "Volver al sitio",
      toc: "En esta página",
      sections: [
        {
          id: "controller",
          heading: "1. Responsable del tratamiento",
          body:
            "DEPP C&M, S.A. DE C.V. (\"DEPP C&M\", \"nosotros\" o \"la Compañía\"), con domicilio en Villahermosa, Tabasco, México, y mesa operativa en Houston, TX (EE.UU.), es la parte responsable del tratamiento, uso y protección de tus datos personales, en cumplimiento de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (\"LFPDPPP\") de México, su Reglamento, los Lineamientos del Aviso de Privacidad emitidos por el INAI, y las leyes aplicables de privacidad de los Estados Unidos (incluyendo, cuando aplique, la California Consumer Privacy Act, \"CCPA\"/\"CPRA\").",
        },
        {
          id: "data",
          heading: "2. Datos personales que recabamos",
          body:
            "Dependiendo del canal que utilices para interactuar con nosotros, DEPP C&M puede recabar las siguientes categorías de datos personales:",
          list: [
            "Datos de identificación: nombre completo, nacionalidad, firma, fotografía.",
            "Datos de contacto: correo corporativo, teléfono, país de residencia, empresa, puesto.",
            "Datos comerciales y profesionales: tamaño de la empresa, rol, tipo de proyecto, briefing técnico, alcance, plazo.",
            "Datos laborales (para candidatos): currículum/CV, formación académica, certificaciones (OSHA, API, ASNT, ISO), años de experiencia, puesto esperado, expectativa de compensación, referencias.",
            "Datos de navegación: dirección IP, tipo de dispositivo, navegador, ubicación aproximada, páginas visitadas, marcas de tiempo (vía cookies y analítica).",
          ],
          body2:
            "No recabamos de manera intencional datos personales sensibles. No recabamos datos personales de menores de edad.",
        },
        {
          id: "purposes",
          heading: "3. Finalidades del tratamiento",
          body: "Finalidades primarias (necesarias para mantener la relación):",
          list: [
            "Atender consultas enviadas a través del formulario de Asesoría Privada.",
            "Evaluar la viabilidad comercial y técnica de un posible proyecto.",
            "Emitir propuestas, contratos, facturación y prestar los servicios contratados.",
            "Gestionar aplicaciones a nuestra bolsa de talento y procesos de reclutamiento.",
            "Cumplir obligaciones legales, fiscales, regulatorias y contractuales.",
            "Garantizar la seguridad de la información y la integridad de nuestros sistemas.",
          ],
          body2: "Finalidades secundarias (puedes oponerte en cualquier momento):",
          list2: [
            "Enviar comunicaciones comerciales, boletines y análisis de la industria.",
            "Invitarte a eventos, webinars y publicaciones.",
            "Investigación de mercado y encuestas de calidad del servicio.",
          ],
          body3:
            "Si no deseas que tus datos personales sean tratados para las finalidades secundarias, por favor indícalo enviando un correo a privacidad@deppcm.com. La negativa no condicionará la prestación del servicio principal.",
        },
        {
          id: "transfers",
          heading: "4. Transferencias de datos",
          body:
            "DEPP C&M podrá transferir tus datos personales, sin requerir tu consentimiento conforme a los supuestos del artículo 37 de la LFPDPPP y las excepciones aplicables en EE.UU., en los siguientes casos:",
          list: [
            "A filiales, subsidiarias o empresas del grupo DEPP C&M para las mismas finalidades señaladas en este aviso.",
            "A autoridades, órganos reguladores o tribunales cuando lo requiera la ley.",
            "A auditores, asesores legales, fiscales y aseguradoras, obligados por confidencialidad.",
            "A subcontratistas y proveedores estrictamente necesarios para la ejecución de un proyecto contratado, sujetos a confidencialidad y obligaciones equivalentes de protección de datos.",
          ],
          body2:
            "Cualquier transferencia fuera de estos supuestos requerirá tu consentimiento previo. No vendemos tus datos personales.",
        },
        {
          id: "arco",
          heading: "5. Derechos ARCO y derechos del consumidor (CCPA)",
          body:
            "Tienes derecho a Acceder, Rectificar, Cancelar u Oponerte (ARCO) al tratamiento de tus datos personales, así como a limitar su uso o divulgación y a revocar el consentimiento otorgado. Si eres residente de California, también tienes los derechos a conocer, eliminar, corregir, oponerte a la venta/compartición de tus datos y a no ser discriminado bajo CCPA/CPRA.",
          body2:
            "Para ejercer estos derechos, envía una solicitud por escrito a privacidad@deppcm.com, incluyendo: (i) nombre completo y medio de contacto; (ii) documentos que acrediten tu identidad o representación legal; (iii) descripción clara de los datos personales y el derecho que deseas ejercer; y (iv) cualquier otro elemento que facilite la localización de tus datos. Responderemos en los plazos establecidos por la ley aplicable (20 días hábiles bajo LFPDPPP; 45 días bajo CCPA).",
        },
        {
          id: "revoke",
          heading: "6. Revocación del consentimiento",
          body:
            "Puedes revocar en cualquier momento el consentimiento que has otorgado para el tratamiento de tus datos personales. Sin embargo, tu solicitud podría no ser de efectos inmediatos cuando una obligación legal requiera que continuemos tratando tus datos, o cuando la terminación del tratamiento afecte una relación jurídica existente.",
        },
        {
          id: "cookies",
          heading: "7. Cookies y tecnologías de rastreo",
          body:
            "Nuestro sitio web puede utilizar cookies, web beacons y tecnologías similares para: (i) asegurar la operación básica del sitio; (ii) recordar preferencias de idioma; (iii) medir audiencia y patrones de uso (analítica). Puedes deshabilitar estas tecnologías desde la configuración de tu navegador, lo que puede limitar ciertas funcionalidades.",
        },
        {
          id: "security",
          heading: "8. Medidas de seguridad",
          body:
            "DEPP C&M ha implementado medidas de seguridad administrativas, técnicas y físicas razonablemente alineadas con los principios de ISO/IEC 27001 y buenas prácticas de SGSI, para proteger tus datos personales contra daño, pérdida, alteración, destrucción, o uso, acceso o tratamiento no autorizado.",
        },
        {
          id: "retention",
          heading: "9. Conservación de los datos",
          body:
            "Los datos personales se conservarán únicamente por el plazo necesario para cumplir las finalidades descritas, más los plazos de conservación legal exigidos por la normativa mexicana y estadounidense (incluyendo regulación fiscal y laboral). Posteriormente serán eliminados o anonimizados.",
        },
        {
          id: "changes",
          heading: "10. Cambios al aviso de privacidad",
          body:
            "El presente Aviso de Privacidad puede actualizarse para reflejar cambios legales, operativos o tecnológicos. Cualquier modificación será publicada en esta página con la fecha de versión actualizada. El uso continuado de nuestros servicios después de la publicación de los cambios implica tu aceptación.",
        },
        {
          id: "contact",
          heading: "11. Contacto — Oficial de Protección de Datos",
          body:
            "Para cualquier duda relacionada con el tratamiento de tus datos personales, o para ejercer tus derechos ARCO o los derechos CCPA, contacta a: DEPP C&M — Oficial de Protección de Datos · privacidad@deppcm.com · Villahermosa, Tabasco, México.",
        },
      ],
      accept: "Entendido",
    },
  },
};
